// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xy9D","clinicsSelect":"styles_clinicsSelect__3ZyNY"};